import { Link } from "react-router-dom";
import {Transition} from "./Animation/Transition"

const SocialIcons = ()=>{
    return(
        <div className=" flex flex-row  gap-2 justify-between">
        <a className=" p-0 m-0 none flex text-black bg-none" href="https://www.facebook.com/cit.chennai.71" target="_blank" rel="noreferrer"><img className="p-4 border-black border"  src="/images/icons/facebook.svg" alt="social icons" /></a>
        <a className=" p-0 m-0 none flex text-black bg-none" href="https://x.com/traders_city?s=20" target="_blank" rel="noreferrer"><img className="p-4 border-black border"  src="/images/icons/twiter.svg" alt="social icons" /></a>
        <a className=" p-0 m-0 none flex text-black bg-none" href="https://www.linkedin.com/in/city-industrial-traders-b10726169/" target="_blank" rel="noreferrer" ><img className="p-4 border-black border"  src="/images/icons/linkedin.svg" alt="social icons" /></a>
        <a className=" p-0 m-0 none flex text-black bg-none" href="https://www.instagram.com/cityindustrial?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer" ><img className="p-4 border-black border"  src="/images/icons/insta.svg" alt="social icons" /></a>
        </div>
    )
}

const Footer = ()=>{
    return(
        <div className="w-full bg-footer min-h-[20vh] list-none sm:p-10 text-black">
            <div className="flex flex-col lg:grid lg:grid-cols-3 justify-center items-start gap-16 p-10 sm:p-0 xl:px-32">
                <Transition duration={1} delay={0.3}>
                    <div className=" flex flex-col gap-3 w-56 col-span-1">
                        <img width={40} src="/images/icons/logo2.png" alt="logo" />
                        <p className="text-lg font-roboto font-[700] text-black">City Industrial Traders</p>
                        <SocialIcons/>
                    </div>
                </Transition>
                <div className=" flex flex-col col-span-2 w-full md:flex-row gap-16  items-center md:items-start md:justify-center font-inter text-base text-textSecondary">
                    <div className="w-full">
                        <Transition duration={1} delay={0.4} className="w-full">
                        <h3 className=" text-lg font-roboto font-[700] text-black pb-3">Explore</h3>
                        <ul className="grid grid-cols-2 justify-items-stretch w-full  md:flex md:flex-col gap-1">
                            <Link to={"/"}><li className="flex hover:text-white text-black"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Home</li></Link>
                            <Link to={"/about"}><li className="flex hover:text-white text-black"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; About Us</li></Link>
                            <Link to={"/certificates"}><li className="flex hover:text-white text-black"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Certificates</li></Link>
                            <Link to={"/product_list"}><li className="flex hover:text-white text-black"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Products</li></Link>
                            <Link to={"/contact"}><li className="flex hover:text-white text-black"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Contact Us</li></Link>
                        </ul>
                        </Transition>
                    </div>
                    {/* Utility Pages links */}
                    {/* <div>
                        <h3 className=" text-lg font-roboto font-[700] text-white pb-3">Utility Pages</h3>
                        <ul className="flex flex-col gap-1">
                            <li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Start here</li>
                            <li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Style guide</li>
                            <Link to={"/404"}><li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; 404 not found</li></Link>
                            <li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Password protected</li>
                            <li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Licenses</li>
                            <li className="flex"> <img width={20} src="/images/icons/dotIcon.svg" alt="dot icon"/> &nbsp; Changelog</li>
                        </ul>
                    </div> */}
                    <div className="w-full">
                        <Transition duration={1} delay={0.5} className="w-full">
                            <h3 className=" text-lg font-roboto font-[700] text-black pb-3">Keep in Touch</h3>
                            <ul className=" flex flex-col gap-1.5 text-black">
                                <li className=" flex gap-2">
                                    <p className=" basis-1/3">Address :</p>
                                    <p className=" basis-2/3"># 92 (Old-44), Sembudoss Street, Chennai-600 001.</p>
                                </li>
                                <li className=" flex gap-2">
                                    <p className=" basis-1/3">Mail :</p>
                                    <p className=" basis-2/3">info@cityindustrials.com</p>
                                </li>
                                <li className=" flex gap-2 items-center">
                                    <p className=" basis-1/3">Phone :</p>
                                    <p className=" basis-2/3">+91 44 2522 8568<br/>+91 44 4216 1860<br/>+91 44 2524 5860</p>
                                </li>
                            
                            </ul>
                        </Transition>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <div className=" w-[70vw] h-[1px] bg-black mx-auto opacity-20"></div>
            <div className=" flex flex-col text-sm sm:text-base  text-center md:flex-row gap-3 w-full justify-center py-4">
            <Transition duration={1} delay={0.4}>
                <li>© 2023 Cityindustrialtraders.All Rights Reserved.</li>
                <div className="flex flex-row justify-center gap-2 sm:gap-3">
                <li>Privacy Policy</li>
                <li>Cookie Policy</li>
                <li>Terms of Service</li>
                </div>
            </Transition>
            </div>
        </div>
    )
}

export default Footer;